import React from 'react';

export default function Landing() {
    return (
        <div className='landing'>
            <div className='fig-1'></div>
            <div className='fig-2'></div>
            <div className='fig-3'></div>
            <div className='fig-4'></div>
            <div className='fig-5'></div>
            <div className='fig-6'></div>
        </div>
    )
}
